// @flow
import React from 'react'


import { VARIANT_DANGER } from '../../constants/variants'

import { Body } from './Typography'

export const ErrorText = ({ error, ...props }: { error: String}) => (
  <Body tradId={error} variant={VARIANT_DANGER} {...props} />
)
